import { memo, useEffect, useState } from 'react';
import { useInstantSearch } from 'react-instantsearch';

import { sendErrorToServices } from 'lib/logging';
import { toast } from 'sonner';

function SearchErrorToast(): null {
  const { addMiddlewares } = useInstantSearch();
  const [error, setError] = useState<string | null>(null);
  const [hasSentError, setHasSentError] = useState(false);

  useEffect(() => {
    const middleware = ({ instantSearchInstance }) => {
      function handleError(searchError: Error) {
        let friendlyMessage = 'An unexpected error occurred.';
        if (
          searchError.message.includes(
            'Cannot convert undefined or null to object'
          )
        ) {
          friendlyMessage =
            'There was a connectivity issue with our search service. Please try again.';
        }

        setError(friendlyMessage);

        if (!hasSentError) {
          toast.error(friendlyMessage);
          sendErrorToServices('Search Error', searchError);
          setHasSentError(true);
        }
      }

      return {
        subscribe() {
          instantSearchInstance.addListener('error', handleError);
        },
        unsubscribe() {
          instantSearchInstance.removeListener('error', handleError);
        }
      };
    };

    return addMiddlewares(middleware);
  }, [addMiddlewares, hasSentError]);

  useEffect(() => {
    if (error === null) {
      setHasSentError(false);
    }
  }, [error]);

  return null;
}

export default memo(SearchErrorToast);
